import { BaseBot } from "./Soribot";
import { Uid } from "./User";
import { BotType } from "./local/Types";

export class AIBot extends BaseBot {

  public pineconeConfig?: PineconeConfig;
  public openAIConfig?: OpenAIConfig;
  public systemRole?: string;
  public beforePrompt?: string;
  public afterPrompt?: string;

  constructor(type: BotType) {
    super(type);

    this.id = AIBot.newId(type);

    if (type == 'ai-chatgpt') {
      this.name = 'ChatGPT';
    } else if (type == 'ai-dalle') {
      this.name = 'DALL-E';
    } else if (type == 'ai-search') {
      this.name = 'Search';
    } else if (type == 'ai-openai-pinecone') {
      this.name = 'PineconeChat';
    } else if (type == 'ai-docubot') {
      this.name = 'DocuBot';
    } else
      this.name = 'UNKNOWN';
  }

  public static getDescription(type: BotType): string {
    if (type == 'ai-chatgpt') {
      return 'Depricated. Use Soribot instead.';
    }
    else if (type == 'ai-dalle') {
      return 'Create images from words';
    }
    else if (type == 'ai-search') {
      return 'Get answers from the web';
    }
    else if (type == 'ai-openai-pinecone') {
      return 'ChatGPT + Pinecone storage';
    } else if (type == 'ai-docubot') {
      return 'Trained bot with documents';
    }
    else
      return 'UNKNOWN';
  }

  public static newId(type: BotType): string {
    return `${type}--${Uid.get().substring(0, 8)}`;
  }
}

export class PineconeConfig {
  constructor(public apiKey: string, public index: string, public region: string) { }
}

export class OpenAIConfig {
  constructor(public systemRole: string) { }
}
